module.exports = __webpack_public_path__ + "img/cst3.514b4db8.png";